import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {ThreeDots} from '../../../../common/threeDots';
import {CellAuthorWrapper, CellAuthorWrapperProps} from './cellAuthorWrapper';
import {unreadCommentLightBlue} from './cellCommentLine';

/*
 * Props.
 */

interface CellCommentingPrecogProps extends CellAuthorWrapperProps {
  isSelected?: boolean;
}

/*
 * Style.
 */

interface PrecogStyleProps {
  $isSelected?: boolean;
}
const StyledPrecogDiv = styled.div<PrecogStyleProps>`
  display: flex;
  align-items: center;

  height: 20px;
  padding: 0 8px;

  border-radius: 10px;
  background-color: ${(p) => (p.$isSelected ? p.theme.alphas.white30 : unreadCommentLightBlue)};
`;

/*
 * Component.
 */

export const CellCommentingPrecog: FC<CellCommentingPrecogProps> = (props) => {
  const theme = useUserTheme();
  const threeDotsColor = props.isSelected ? theme.greys.white : theme.palette.blue.shade40;
  return (
    <CellAuthorWrapper {...props}>
      <StyledPrecogDiv $isSelected={props.isSelected}>
        <ThreeDots color={threeDotsColor} size={VisualSizesEnum.SMALL} />
      </StyledPrecogDiv>
    </CellAuthorWrapper>
  );
};
